export default __webpack_public_path__ + "static/media/mob_preland_7.ea55caca.jpg";